import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';

/**
 * CRM → Yapılandırmalar → Sağlayıcılar → OneSignal: App ID tanımlı ve
 * varsayılan sağlayıcı OneSignal ise sitede OneSignal Web SDK yüklenir ve
 * giriş yapan oyuncu kendi kimliğiyle eşlenir (external_id = üye kimliği).
 * CRM bildirimleri bu kimliğe gönderilir. Panel yollarında yüklenmez.
 */
const SDK = 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js';

const PushSubscribe = () => {
  const { settings } = useSettings();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const appId = settings?.push_onesignal_app_id || '';
  const onAdmin = pathname.startsWith('/admin');

  useEffect(() => {
    if (!appId || onAdmin || typeof window === 'undefined') return;
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    if (!document.querySelector(`script[src="${SDK}"]`)) {
      const script = document.createElement('script');
      script.src = SDK;
      script.defer = true;
      document.head.appendChild(script);
      window.OneSignalDeferred.push(async (OneSignal) => {
        try { await OneSignal.init({ appId, allowLocalhostAsSecureOrigin: true }); } catch (_) { /* yoksay */ }
      });
    }
  }, [appId, onAdmin]);

  useEffect(() => {
    if (!appId || onAdmin || !window.OneSignalDeferred) return;
    window.OneSignalDeferred.push(async (OneSignal) => {
      try {
        if (user?.id) await OneSignal.login(user.id);
        else await OneSignal.logout();
      } catch (_) { /* SDK hazır değil ya da izin yok */ }
    });
  }, [appId, onAdmin, user?.id]);

  return null;
};

export default PushSubscribe;
